import { Theme } from '@infotech-soe/erp-ui-kit';
import { createUseStyles } from 'react-jss';

import { MENU_ROOT_ICON_CLASS } from './constants';

const MENU_WIDTH = 56;
const MENU_WIDTH_EXPANDED = 560;
const MENU_ICON_SIZE = 24;
const MENU_OFFSET = 24;
const MENU_ITEM_HEIGHT = 32;
const MENU_ITEM_PADDING = [0, 16];
const MENU_TOGGLE_BUTTON_HEIGHT = 48;
const MENU_TOGGLE_BUTTON_MARGIN = 8;

export const useMenuStyles = createUseStyles(({ colors }: Theme) => ({
  sidebar: {
    background: colors.backgroundMenu,
    position: 'absolute',
    top: 1,
    bottom: 0,
    left: 0,
    width: MENU_WIDTH_EXPANDED,
    transition: ['width', '.3s'],
  },
  collapsed: {
    width: MENU_WIDTH,
  },
  list: {
    position: 'relative',
    color: colors.typoMenu,
    overflowY: 'auto',
    overflowX: 'hidden',
    height: '100%',
  },
}));

const calculateOffset = (menuNestinglevel = 0) =>
  menuNestinglevel === 0 ? 0 : MENU_WIDTH + menuNestinglevel * MENU_OFFSET;

export const useMenuItemStyles = createUseStyles<
  'label' | 'listItemContainer' | 'optionsButton',
  number,
  Theme
>(({ colors }) => ({
  listItemContainer: {
    boxShadow: 'none !important',
    composes: ['row', 'items-center', 'no-wrap'],
    minHeight: MENU_ITEM_HEIGHT,
    overflow: 'hidden',
    [`& .${MENU_ROOT_ICON_CLASS}`]: {
      padding: MENU_ITEM_PADDING,
      fontSize: MENU_ICON_SIZE,
    },
    paddingLeft: calculateOffset,
    '&:hover .optionsIcon, &:focus .optionsIcon': {
      color: colors.typoMenu,
      '&:hover': {
        color: colors.typoPrimary,
      },
    },
  },
  label: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    flex: 1,
  },
  optionsButton: {
    color: colors.backgroundMenu,
    padding: 3,
  },
}));

export const useGroupItemStyles = createUseStyles<
  'arrow' | 'label' | 'listHeader',
  number,
  Theme
>({
  label: {
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  arrow: {
    marginRight: 2,
  },
  listHeader: {
    boxShadow: 'none !important',
    composes: ['row', 'no-wrap', 'items-center'],
    minHeight: MENU_ITEM_HEIGHT,
    overflow: 'hidden',
    [`& .${MENU_ROOT_ICON_CLASS}`]: {
      fontSize: MENU_ICON_SIZE,
      padding: MENU_ITEM_PADDING,
    },
    paddingLeft: calculateOffset,
  },
});

export const useSeparatorStyles = createUseStyles({
  separator: {
    marginLeft: calculateOffset,
  },
});

export const useBackdropStyles = createUseStyles<'backdrop', number, Theme>(
  ({ sizes }) => ({
    backdrop: {
      position: 'fixed',
      top: sysNotificationsNumber =>
        sysNotificationsNumber * sizes.systemNotification.height +
        sizes.mainHeader.height,
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: 'rgba(0,0,0,0.1)',
    },
  })
);

export const useToggleButtonStyles = createUseStyles(({ colors }: Theme) => ({
  separator: {
    margin: 0,
  },
  button: {
    position: 'sticky',
    top: 0,
    composes: ['row', 'no-wrap'],
    gap: MENU_OFFSET,
    justifyContent: 'start',
    width: '100%',
    borderRadius: 0,
    height: MENU_TOGGLE_BUTTON_HEIGHT,
    padding: MENU_ITEM_PADDING,
    marginBottom: MENU_TOGGLE_BUTTON_MARGIN,
    color: colors.typoMenu,
    background: colors.backgroundHeader,
  },
}));
